import * as React from 'react';
import './IconMessage.scss';

interface IIconMessageProps {
  icon: string;
  message: string;
  className?: string;
  isIconInline?: boolean;
}

export function IconMessage(props: IIconMessageProps) {
  const className = `rp-icon-message ${
    props.isIconInline ? 'display-inline' : ''
  } ${props.className ? props.className : ''}`;
  return (
    <div className={className}>
      <span className={`${props.icon} rp-icon-message--icon`} />
      <div className="rp-icon-message--message">{props.message}</div>
    </div>
  );
}
